function DekapostInsurance() {
  return (
    <li>
      <span>در سرویس دهنده </span>
      <span className="fs-5 fw-bold">دکاپست</span>
      <span> برای مرسولات از نوع پاکت، فقط ارزش کالا </span>
      <span>2,000,000 ریال</span>
      <span> فعال است</span>
    </li>
  );
}
export default DekapostInsurance;
